import CustomDialog from '../common/CustomDialog/CustomDialog'
import {Box} from '@mui/material'
import PropTypes from 'prop-types'
import {
  StyledFlexBox,
  StyledDialogTitle,
  StyledConfirmationWarningIcon,
  StyledConfirmationDialogButton
} from './ChatbotStyles'

const ConfirmationDialog = ({showDialog, handleConfirm, handleClose}) => {
  const title = (
    <StyledFlexBox>
      <StyledConfirmationWarningIcon />
      <StyledDialogTitle
        variant='titleMedium'
        sx={{
          fontWeight: (theme) => theme.typography.fontWeightBold
        }}
      >
        Are you sure you want to clear the chat history?
      </StyledDialogTitle>
    </StyledFlexBox>
  )

  const footer = (
    <Box>
      <br />
      <StyledFlexBox>
        <StyledConfirmationDialogButton buttonType='cancel' onClick={handleClose}>
          Cancel
        </StyledConfirmationDialogButton>
        <StyledConfirmationDialogButton buttonType='confirm' onClick={handleConfirm}>
          Confirm
        </StyledConfirmationDialogButton>
      </StyledFlexBox>
    </Box>
  )

  return (
    <Box>
      {showDialog && (
        <CustomDialog
          size='sm'
          isOpened={showDialog}
          title={title}
          footer={footer}
          underlineTitle={false}
          handleClose={handleClose}
        />
      )}
    </Box>
  )
}

ConfirmationDialog.propTypes = {
  showDialog: PropTypes.bool,
  handleConfirm: PropTypes.func,
  handleClose: PropTypes.func
}

export default ConfirmationDialog
